var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._l((_vm.galleries),function(gallery){return _c('div',{key:gallery.id},[_c('Gallery',{attrs:{"gallery-type":_vm.galleryType,"gallery":gallery}})],1)}),_c('ModalCurrencyMismatch')],2)
}
var staticRenderFns = []

export { render, staticRenderFns }